<template>
  <div class="app-personal-data-full-form">
    <slot name="txtBefore"></slot>
    <b-form>
      <b-form-group class="gender-group">
        <b-row>
          <b-col md="" sm="12" class="label-col">
            <label class="mandatory d-inline-block"><slot name="genderLabel">Anrede</slot></label>
          </b-col>
          <b-col md="" sm="12" class="form-col gender-col">
            <b-form-radio-group
              required
              v-model="person_.gender"
              @input="$v.person.gender.$touch"
              :state="isValid('gender', 'person')"
            >
              <b-form-radio name="gender" value="FEMALE">Frau</b-form-radio>
              <b-form-radio name="gender" value="MALE">Herr</b-form-radio>
            </b-form-radio-group>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group class="first-name-group">
        <b-row>
          <b-col md="" sm="12" class="label-col">
            <label class="mandatory d-inline-block"><slot name="firstNameLabel">Vorname</slot></label>
          </b-col>
          <b-col md="" sm="12" class="form-col first-name-col">
            <b-form-input
              name="firstName"
              type="text"
              required
              v-model="person_.firstName"
              @input="$v.person.firstName.$touch"
              :state="isValid('firstName', 'person')"
            >
            </b-form-input>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group class="last-name-group">
        <b-row>
          <b-col md="" sm="12" class="label-col">
            <label class="mandatory d-inline-block"><slot name="lastNameLabel">Nachname</slot></label>
          </b-col>
          <b-col md="" sm="12" class="form-col last-name-col">
            <b-form-input
              name="lastName"
              type="text"
              required
              v-model="person_.lastName"
              @input="$v.person.lastName.$touch"
              :state="isValid('lastName', 'person')"
            ></b-form-input>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group class="street-group">
        <b-row>
          <b-col md="" sm="12" class="label-col">
            <label class="mandatory d-inline-block"><slot name="streetLabel">Strasse / Hausnummer</slot></label>
          </b-col>
          <b-col md="" sm="12" class="form-col street-col">
            <b-form-input
              name="street"
              type="text"
              required
              v-model="person_.address.street"
              @input="$v.person.address.street.$touch"
              :state="isValid('street','address','person')"
            ></b-form-input>
          </b-col>
          <b-col md="" sm="12" class="form-col house-number-col">
            <b-form-input
              name="houseNumber"
              type="text"
              required
              v-model="person_.address.houseNumber"
              @input="$v.person.address.houseNumber.$touch"
              :state="isValid('houseNumber','address','person')"
            ></b-form-input>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group class="supplement-group">
        <b-row>
          <b-col md="" sm="12" class="label-col">
            <label class="d-inline-block"><slot name="supplementLabel">Adresszusatz</slot></label>
          </b-col>
          <b-col md="" sm="12" class="form-col supplement-col">
            <b-form-input
              name="supplement"
              type="text"
              v-model="person_.address.supplement"
            ></b-form-input>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group class="zip-group">
        <b-row>
          <b-col md="" sm="12" class="label-col">
            <label class="mandatory d-inline-block"><slot name="zipLabel">PLZ / Ort</slot></label>
          </b-col>
          <b-col md="" sm="12" class="form-col zip-col">
            <b-form-input
              name="zip"
              type="text"
              required
              v-model="person_.address.zip"
              @input="$v.person.address.zip.$touch"
              :state="isValid('zip', 'address','person')"
            ></b-form-input>
          </b-col>
          <b-col md="" sm="12" class="form-col city-col">
            <b-form-input
              name="city"
              type="text"
              required
              v-model="person_.address.city"
              @input="$v.person.address.city.$touch"
              :state="isValid('city', 'address','person')"
            ></b-form-input>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group class="birth-date-group">
        <b-row>
          <b-col md="" sm="12" class="label-col">
            <label class="mandatory d-inline-block"><slot name="zipLabel">Geburtsdatum</slot></label>
          </b-col>
          <b-col md="" sm="12" class="form-col birth-date-col">
            <b-input-group class="mb-3">
              <b-form-input
                type="text"
                name="birthDate"
                placeholder="TT.MM.JJJJ"
                required
                v-model="person_.birthDate"
                @input="$v.person.birthDate.$touch"
                :state="isValid('birthDate', 'person')"
              ></b-form-input>
              <b-input-group-append>
                <b-form-datepicker
                  v-bind="calendarSettings || {}"
                  button-only
                  right
                  required
                  @input="$v.person.birthDate.$touch"
                  :state="isValid('birthDate', 'person')"
                  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                  @context="selectDate"
                  :aria-controls="'birthdate' + _uid"
                ></b-form-datepicker>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group class="email-group">
        <b-row>
          <b-col md="" sm="12" class="label-col">
            <label class="mandatory d-inline-block"><slot name="emailLabel">E-Mail-Adresse</slot></label>
          </b-col>
          <b-col md="" sm="12" class="form-col email-col">
            <b-form-input
              name="email"
              type="email"
              required
              v-model="person_.email"
              @input="$v.person.email.$touch"
              :state="isValid('email', 'person')"
            ></b-form-input>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group class="email-repeat-group">
        <b-row>
          <b-col md="" sm="12" class="label-col">
            <label class="mandatory d-inline-block"><slot name="emailRepeatLabel">E-Mail-Adresse wiederholen</slot></label>
          </b-col>
          <b-col md="" sm="12" class="form-col email-repeat-col">
            <b-form-input
              name="email-repeat"
              type="email"
              required
              v-model="emailRepeat_"
              @input="$v.emailRepeat.$touch"
              :state="isValid('emailRepeat')"
            ></b-form-input>
          </b-col>
        </b-row>
      </b-form-group>
    </b-form>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import { BForm, BFormGroup, BFormInput } from 'bootstrap-vue'
import syncProperty from '@/mixins/syncProperty'
import slotProxy from '@/mixins/slotProxy'
import { required, sameAs, email } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import isValid from '../../../../../mixins/isValid'
import { validZipCode, validCityString } from '@/validators/address'
import { validDate, validDateFormat } from '@/validators/date'
export default {
  name: 'PersonalDataFullForm',
  components: {
    BFormGroup,
    BForm,
    BFormInput
  },
  watch: {
    '$v.$invalid': {
      immediate: true,
      handler: function (newValue) {
        this.$emit('update:invalid', newValue)
      }
    }
  },
  methods: {
    validate () {
    },
    selectDate (ctx) {
      if (ctx.selectedDate) {
        this.person.birthDate = ctx.selectedFormatted
      }
    }
  },
  mixins: [
    validationMixin,
    isValid,
    slotProxy(),
    syncProperty('person', 'person_'),
    syncProperty('emailRepeat', 'emailRepeat_')
  ],
  computed: {
    calendarSettings () {
      return this.$config.calendar.calendarSettings
    }
  },
  validations () {
    return {
      person: {
        address: {
          street: {
            required
          },
          houseNumber: {
            required
          },
          zip: {
            required,
            validZipCode
          },
          city: {
            required,
            validCityString
          }
        },
        birthDate: {
          required,
          validDate,
          validDateFormat
        },
        email: {
          required,
          email
        },
        firstName: {
          required
        },
        gender: {
          required
        },
        lastName: {
          required
        }
      },
      emailRepeat: {
        required,
        email,
        sameAsEmail: sameAs(function () {
          return this.person.email
        })
      }
    }
  }
}
</script>
